/** A link target the board may open: absolute http(s) or mailto, never javascript:, data: or relative URLs. */
export function safeHref(href: unknown): string | null {
  if (typeof href !== 'string') return null;
  try {
    const u = new URL(href.trim());
    return u.protocol === 'http:' || u.protocol === 'https:' || u.protocol === 'mailto:' ? href.trim() : null;
  } catch {
    return null;
  }
}

/** A text color written by a peer: #rgb, #rrggbb or rgb(r, g, b) only (nothing that can smuggle CSS). */
export function safeColor(c: unknown): string | null {
  if (typeof c !== 'string') return null;
  return /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i.test(c) || /^rgb\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\)$/.test(c) ? c : null;
}
